import { createElement } from "../jsx.js";
const depths = [1, 2, 3, 4];
function getAllowedDepth(d) {
    const found = depths.indexOf(d);
    if (found >= 0) {
        return d;
    }
    return depths[depths.length - 1];
}
const styles = {
    h1: `text-2xl font-extrabold text-black leading-tight mt-6`,
    h2: `text-2xl font-extrabold text-black leading-tight mt-6`,
    h3: `font-extrabold text-black leading-tight mt-4`,
    h4: `text-black leading-tight mt-4`,
};
export function Heading(props) {
    const depth = getAllowedDepth(props.depth);
    const component = `h${depth}`;
    const style = styles[component];
    return createElement(component, { className: style }, props.children);
}
